/**
 * Combine all sagas in this file and export the rootSaga.
 */

import {all} from 'redux-saga/effects';
import orderSaga from '../pages/orders/saga';
import parcelsSaga from '../pages/parcels/saga';
import warehouseSaga from '../pages/warehouses/saga';
import loginSaga from '../pages/login/saga';
import driversSaga from '../pages/drivers/saga';
import partnersSaga from '../pages/partners/saga';
import centerSaga from '../pages/centers/saga';
import productSaga from '../pages/products/saga';
import reportsSaga from '../pages/reports/saga';
import providerSaga from '../pages/providers/saga';
import sellerSaga from '../pages/sellers/saga';
import webHooksSaga from '../pages/webhooks/saga';
import notificationSaga from '../pages/notification/notificationSaga/saga';
import paymentSaga from '../pages/payment/saga/saga';

export default function* rootSaga() {
  yield all([
    loginSaga(),
    orderSaga(),
    parcelsSaga(),
    warehouseSaga(),
    driversSaga(),
    centerSaga(),
    partnersSaga(),
    productSaga(),
    reportsSaga(),
    providerSaga(),
    sellerSaga(),
    webHooksSaga(),
    notificationSaga(),
    paymentSaga(),
  ]);
}
